import styled, { css } from 'styled-components';
import { lighten, darken, transparentize } from 'polished';
import { Img } from 'react-image';
import { Form as FormBase } from '@unform/web';
import { CircularProgressbar } from 'react-circular-progressbar';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { ButtonBase } from 'components/Button/styles';
import { Container as FlagContainer } from 'components/Flag/styles';
import Avatar from 'components/Avatar';
import { SelectComponent as AsyncSelectCreatableContainer } from 'components/AsyncSelectCreatable/styles';
import { Container as CheckboxContainer } from 'components/Checkbox/styles';

import { device } from 'styles/device';
import { FlagProps } from 'components/Flag';
interface ActionsProps {
  $display?: string;
  $flex?: boolean;
}
interface AvaliadoresAvatarProps {
  checked: boolean;
}
interface FilterItemProps {
  $hide?: 'desktop' | 'laptop';
}
interface PatrocinioItemProps {
  flag:
    | 'pendente'
    | 'indisponivel'
    | 'entregue'
    | 'reenvio'
    | 'emAndamento'
    | 'erro';
}
interface InfoProps {
  margin?: boolean;
  align?: string;
}
interface ColumnContentProps {
  margin?: string;
  columns?: string;
}
interface ThumbnailContainerProps {
  $mini: boolean;
  inUpload: boolean;
  disabled: boolean;
}
interface DropContainerProps {
  isDragReject: boolean;
  isDragActive: boolean;
}
interface ScrollProps {
  height?: string;
}
interface ThProps {
  $hide?: 'desktop' | 'laptopM';
}
interface TdProps {
  size?: string;
  $hide?: 'desktop' | 'laptopM';
  disabled?: boolean;
}

interface TdFlagProps {
  size?: string;
  type: FlagProps['type'];
  $hasMidia: boolean;
  $avaliacaoEngPendente: boolean;
}

export const Container = styled.div`
  /* display: flex; */
  /* flex-direction: column; */
  width: 100%;
  display: flex;
  flex-direction: column;
  /* height: auto; */
  height: 100%;
  padding: 0;
  margin: 0;

  header {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    padding-bottom: 10px;

    ${ButtonBase} {
      &:first-of-type {
        margin-right: 10px;
      }
    }

    button {
      svg {
        margin-left: 5px;
      }
    }
    /* div {
      display: flex;
      align-items: center;
      min-width: 250px;
      width: 100%;
    } */

    h4 {
      min-width: 130px;
    }
  }
`;

export const WidgetContent = styled.div`
  flex-grow: auto;
  display: flex;
  flex-direction: row;
`;

export const FilterContent = styled.div`
  flex-grow: auto;
  display: flex;
  flex-direction: row;

  height: 125px;
  margin: 5px 0 15px 10px;
  align-items: center;
  > span {
    color: ${props => props.theme.loadingTableColor};
    font-weight: 400;
    position: absolute;
    transform: rotate(-90deg);
    height: 10px;
    font-size: 1rem;
    margin-left: -45px;
    letter-spacing: 3px;
  }
`;

export const Content = styled.div`
  padding: 0 15px 0 15px;
  flex: 1 1;
`;

export const FormContent = styled.div`
  flex: 1 1;
`;
export const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Form = styled(FormBase)`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  section {
    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};

    &:first-of-type {
      margin: 0px 0 15px 0;
    }

    ${ButtonBase} {
      margin-top: -10px;
    }
  }
`;

export const Th = styled.th<ThProps>`
  ${props =>
    !!props.$hide &&
    css`
      @media ${device[props.$hide]} {
        display: none;
      }
    `}
`;

export const Td = styled.td<TdProps>`
  padding: 10px 10px 10px 0px !important;
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color:${props =>
    props.disabled
      ? props.theme.secondaryFontColor
      : props.theme.fontColor} !important;
  text-decoration: ${props => (props.disabled ? 'line-through' : 'none')};

  ${props =>
    !!props.$hide &&
    css`
      @media ${device[props.$hide]} {
        display: none;
      }
    `}

  strong {
    /* opacity:  ${props => (props.disabled ? 1 : 0.2)};
  color: ${props => (props.disabled ? 'red' : props.theme.fontColor)}; */
  color:${props =>
    props.disabled
      ? props.theme.secondaryFontColor
      : props.theme.fontColor} !important;
    margin-left: 5px;
    font-size: 0.88rem;
    font-weight: normal;
    font-style: italic;

    &:before {
      content: '-';
      margin-right: 10px;
    }
  }
//Comentado estilização de button dentro de tabelas
// Sem margin, eles se agrupam na direita da tabela e os botões na tela de
//aprovacao ficam melhor centralizados
  /* button {
    margin: 0 auto !important;
  } */
`;

export const TdFlag = styled.td<TdFlagProps>`
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};
  padding: 0 !important;

  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;

    background-color: ${props => props.theme.flag[props.type]};
    ${props =>
      !props.$hasMidia || props.$avaliacaoEngPendente ? 'opacity: 0.3' : ''}
  }
`;

export const FormFilter = styled(FormBase)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;

  section {
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    height: 100% !important;
    flex: 1;

    p {
      font-size: 0.8rem;
      padding: 0px 5px;
      color: ${props => props.theme.fontColor};
      opacity: 0.7;
    }

    ${AsyncSelectCreatableContainer} {
      margin-bottom: 10px;
    }
  }
`;

export const FilterItem = styled.fieldset<FilterItemProps>`
  padding: 10px 0 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.loadingTableColor};
  margin-right: 5px;
  &:first-of-type {
    margin-left: 20px;
  }
  &:last-of-type {
    margin-right: 0px;
  }

  ${props =>
    !!props.$hide &&
    css`
      @media ${device[props.$hide]} {
        display: none;
      }
    `}

  legend {
    font-size: 0.8rem;
    padding: 0px 5px;
    color: ${props => props.theme.fontColor};
    opacity: 0.7;
  }

  div {
    /* display: flex; */
    align-items: center;
    justify-content: center;
    margin-bottom: none;
  }
`;

export const DadosLocucao = styled.div`
  > div {
    margin-bottom: 15px;
  }
`;

export const DadosProducao = styled.div`
  display: flex;
  margin-top: 5px;
  overflow: hidden;
  height: fit-content;

  div {
    flex: 1;

    section {
      flex: 1;
      padding: 24px 8px 8px !important;
      background: ${props =>
        props.theme.name === 'dark'
          ? lighten(0.05, props.theme.cardBackgroud)
          : darken(0.05, props.theme.cardBackgroud)};
      position: relative;
      border-radius: 5px;
      border-bottom: none;
      span {
        opacity: 0.5;
        position: absolute;
        font-size: 12px;
        top: 4px;
        left: 8px;
      }
      h5 {
        z-index: 2;
        justify-self: flex-end;
        position: relative;
      }
      p {
        position: relative;
        z-index: 2;
        margin-top: 10px;
        font-size: 14px;
      }
      svg {
        position: absolute;
        color: ${props => props.theme.cardBackgroud};
        z-index: 1;
        font-size: 100px;
        bottom: 0;
        right: -35px;
        bottom: -16px;
      }
    }
  }
`;

export const CenteredTableData = styled.td`
  display: flex;
  justify-content: center;
`;

export const ComunicadorModal = styled.td`
  div {
    button {
      margin-top: 15px;
      justify-self: center;
    }
  }
`;

export const ModalAvaliacao = styled.div`
  button {
    margin: 3rem auto 0 auto;
  }
  textarea {
    margin-top: 2rem;
  }
`;

export const PatrocinioItem = styled.div<PatrocinioItemProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  place-items: center;
  margin-bottom: 5px;
  background: ${props =>
    props.theme.name === 'dark'
      ? lighten(0.05, props.theme.cardBackgroud)
      : darken(0.05, props.theme.cardBackgroud)};
  border-radius: 5px;
  padding: 8px 8px 8px 0;
  line-height: 1.2rem;

  div:first-of-type {
    margin-top: 0px !important;
    margin-left: 10px !important;
    flex: 1;
  }

  div {
    flex: 0;
  }

  span {
    opacity: 0.8;
    font-weight: 500;
    font-size: 12px;
  }
  p {
    font-size: 14px;
    i {
      font-size: 12px;
      opacity: 0.8;
    }
  }

  &::before {
    content: '';
    position: absolute;
    height: 80%;
    width: 3px;
    left: 0;
    top: 10%;
    background: ${props => props.theme.flag[props.flag]};
  }
`;

export const DadosPatrocinio = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  > p {
    span {
      font-size: 0.95rem;
      font-style: italic;
    }
  }
  svg {
    font-size: 1.5rem;
    color: ${props => props.theme.fontColor};
    margin-left: 1rem;
  }
`;
export const VinhetaPatrocinio = styled.div`
  margin-bottom: 1rem;
`;

export const ColumnContent = styled.div<ColumnContentProps>`
  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-columns: ${props => props.columns};
  grid-column-start: 1;
  grid-column-end: 2;
  /* margin-bottom: 10px; */
  height: 100%;
  @media ${device.laptopM} {
    grid-template-columns: 1fr;
  }
  > div {
    padding-right: 10px;
    margin: ${props => props.margin};
    /* margin-bottom: auto; */
  }

  section {
    display: flex;
    justify-content: space-between;

    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};

    &:first-of-type {
      margin: 0px 0 15px 0;
    }

    ${ButtonBase} {
      margin-top: -10px;
    }
  }
`;
export const ContentCards = styled.div`
  flex: 1 1;
  display: flex;
  flex-direction: row;
  /* overflow: auto; */
  padding: 0 !important;
  position: relative;
  /* height: 100% !important; */
  /* min-height: calc(100vh - 150px) !important; */

  @media ${device.tabletL} {
    flex-direction: column;
  }
`;

export const RightContent = styled.div`
  display: flex;
  flex: 0.8 0.8;
  margin-left: 10px;

  @media ${device.tabletL} {
    margin-left: 0px;
    margin-top: 10px;
  }
`;
export const LeftContent = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  width: 100%;
  div {
    &:last-of-type {
      margin-bottom: 0px;
    }
  }
`;

export const CardContent = styled.div`
  color: #fff;
  display: flex;
  height: inherit;
  flex-direction: column;
  margin-bottom: 1rem;
  justify-content: space-between;
  header {
    display: flex;
    flex-direction: row;
    padding: 0;
    align-items: center;
    justify-content: start;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
    h3 {
      font-size: 1.15rem;
      margin-right: 10px;
    }
  }
  > h4 {
    padding: 10px; /* Padding apenas no loading */
  }
  li {
    margin-bottom: 0.2rem;
  }
`;
export const Midia = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${device.laptopM} {
    flex-direction: column;
  }

  /* flex: 1 1; */
`;

export const Info = styled.div<InfoProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 250px;
  flex: 1 1;
  @media ${device.laptopM} {
    margin-top: 10px;
  }
  img {
    border-radius: 5px;
    /* height: 120px; */
    height: 8rem;
  }
  ${props =>
    props.margin &&
    css`
      margin: 0 15px;
    `}
  ul {
    display: flex;
    width: 100%;
    flex-direction: column;

    li {
      font-weight: 300;
      display: flex;
      flex-direction: row;

      align-items: center;
      flex: 1 1;
      ${props =>
        props.align === 'space-between'
          ? css`
              justify-content: space-between !important;
            `
          : css``}

      div {
        display: flex;
        align-items: center;
      }

      &:first-of-type {
        margin-top: 0;
      }

      /* para corrigir spacing line do ultimo item */
      &:last-of-type {
      }
      strong {
        font-weight: 400;
      }

      p {
        ${props =>
          props.align === 'space-between'
            ? css`
                flex: 1 1;
              `
            : css``};

        margin-right: 8px;
      }

      ${FlagContainer} {
        margin: 0 5px !important;
        &:first-of-type {
          margin-left: 0 !important;
        }
      }

      button {
        margin-left: 3px;
      }
    }
  }
`;

export const ButtonUpload = styled.button`
  position: absolute;
  border: 0;
  padding: 0;
  margin: 0%;
  transition: all 0.2s ease;
  opacity: 0;
  display: flex;
  align-items: center;

  /* margin-left: -15px; */
  border-radius: 15px;
  padding: 6px 6px;

  background-image: linear-gradient(
    to bottom left,
    ${props => props.theme.button.primary.out},
    ${props => props.theme.button.primary.in},
    ${props => props.theme.button.primary.out}
  ) !important;
  background-color: ${props => props.theme.button.primary.out};
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  svg {
    color: #fff;
    font-size: 24px;
  }

  p {
    color: #fff;
    margin-left: 5px;
  }
`;

export const ButtonUploadError = styled.button`
  position: absolute;
  border: 0;
  padding: 0;
  margin: 0%;
  transition: all 0.3s ease;
  opacity: 0;
  display: flex;
  align-items: center;

  /* margin-left: -15px; */
  border-radius: 15px;
  padding: 6px 6px;

  background-image: linear-gradient(
    to bottom left,
    ${props => props.theme.button.danger.out},
    ${props => props.theme.button.danger.in},
    ${props => props.theme.button.danger.out}
  ) !important;
  background-color: ${props => props.theme.button.danger.out};
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  svg {
    color: #fff;
    font-size: 24px;
  }

  p {
    color: #fff;
    margin-left: 5px;
  }

  ${ButtonUpload} {
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const Upload = styled.div`
  display: flex;
  position: relative;
  padding: 0 15px;
  justify-content: center;
  align-items: center;
  &:hover ${ButtonUpload} {
    opacity: 1;
  }
`;

export const DropContainer = styled.div<DropContainerProps>`
  ${ButtonUpload} {
    opacity: ${props => (props.isDragActive ? '1' : '0')};
  }

  ${ButtonUploadError} {
    opacity: ${props => (props.isDragReject ? '1' : '0')};
  }
`;
export const ThumbnailContainer = styled.div<ThumbnailContainerProps>`
  position: relative;
  min-width: 200px;

  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: auto;
    max-width: ${props => (props.$mini ? '200px' : '350px')};

    border-radius: 5px !important;
    cursor: ${props => (props.inUpload ? 'default' : 'pointer')};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    transition: all 0.25s ease;
    filter: ${props =>
      props.inUpload ? 'blur(1px) grayscale(100%)' : 'blur(0px)'};
    &:hover {
      opacity: 1;
      transform: scale(1.1);
    }
  }

  svg {
    position: absolute !important;
  }
`;

export const Image = styled(Img)``;

export const Aprovacao = styled.div`
  /* padding: 15px 15px 0 15px; */
  height: calc(100vh - 480px);
  display: flex;
  flex-direction: column;
  flex: 1.3 1.3;

  header {
    display: flex;
    flex-direction: row;
    padding: 0;
    align-items: center;
    justify-content: start;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
    h3 {
      font-size: 1.15rem;
      margin-right: 10px;
      min-width: auto;
    }
  }
`;

export const CircularContainer = styled(CircularProgressbar)`
  position: absolute;
  opacity: 1;
`;

export const FormAprovadores = styled(FormBase)`
  display: flex;
  padding: 15px 0;
  align-items: center;
  button {
    margin-left: 5px;
  }
`;

export const FormFinalizar = styled(FormBase)`
  display: flex;
  padding: 15px 0;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  button {
    margin-left: 5px;
  }

  h3 {
    font-size: 1.05rem;
    margin-bottom: 10px;
  }
`;
export const Exibidoras = styled.div`
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
`;

export const ListAprovadores = styled.ul`
  display: flex;

  flex-direction: column;
`;

export const Item = styled.li`
  display: flex;
  padding: 5px 0;
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid
    ${props => transparentize(0.6, props.theme.fontColor)};
  &:last-of-type {
    border-bottom: none;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  min-width: 16rem;
  > span {
    margin-left: 10px;
    p {
      font-size: 0.85rem;
    }
    strong {
      font-weight: 400;
      opacity: 0.8;
    }
  }
`;
export const Actions = styled.div<ActionsProps>`
  display: flex;
  ${props =>
    props.$display === 'column'
      ? css`
          flex: ${props.$flex ? '1 1' : null};
          flex-direction: column;
          button {
            &:first-of-type {
              margin-bottom: 10px;
            }
          }
        `
      : null};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: -webkit-fill-available;
  width: -moz-fill-available;
  margin-bottom: 0.5rem;

  margin-right: 0 !important;
  section {
    display: flex;
    flex-direction: row;
    font-size: inherit !important;
    align-items: center;
    justify-content: space-between;

    border-bottom: 0px;
    margin-bottom: -3px !important;
    > svg {
      margin-left: 5px;
      font-size: 28px;
      opacity: 0.8;
    }
    p {
      display: flex;
      align-items: center;
      font-size: 0.85rem;
      > svg {
        margin-left: 5px;
        font-size: 28px;
        opacity: 0.8;
      }
    }
    i {
      opacity: 0.9;
      font-style: oblique;
    }

    span {
      font-size: 0.75rem;
      opacity: 0.8;
      font-style: oblique;
    }
  }
`;

export const SectionDate = styled.section`
  margin: 0 !important;
  > div {
    display: flex;
    align-items: center;
  }

  border: 0px !important;
  margin-bottom: 0px !important;
`;

export const AvaliadoresAvatar = styled(Avatar)<AvaliadoresAvatarProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin: 0 5px 5px 0;
`;

export const ContentEditor = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${CheckboxContainer} {
    margin: 0 0 0 10px !important;
    min-width: 180px !important;
    flex: 0;
  }
`;

export const Scroll = styled(PerfectScrollbar)<ScrollProps>`
  /* max-height: ${props => (props.height ? props.height : '35vh')}; */
  height: ${props => (props.height ? props.height : 'auto')};
  padding: 0px !important;

`;
export const RoteiroScroll = styled(PerfectScrollbar)<ScrollProps>`
  height: calc(100vh - 380px);
  padding: 0px !important;
  * {
    background: ${props => props.theme.cardBackgroud} !important;
  }
`;

export const Link = styled.a<ScrollProps>`
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.theme.fontColor};
`;

export const Patrocinio = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid ${props => props.theme.fontColor};
  border-radius: 20px;
  padding: 1rem;
  margin: 1rem;
  min-height: 370px;
  h4 {
    text-align: center;
    margin-bottom: 0.5rem;
  }
  .dados {
    height: 68px;
    align-content: flex-end;
    margin-top: 1.5rem;
  }
  textarea {
    &:last-of-type {
      margin-top: 0.5rem;
    }
  }
`;
